import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Modal, Row, Col, Typography, Card, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { MailOutlined, KeyOutlined, LockOutlined, ArrowLeftOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import API_ROUTES from '../../api';
import axios from 'axios';

const { Title, Text, Paragraph, Link } = Typography;

export default function ForgetPwd() {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [isDisabled, setIsDisabled] = useState(false);
    const [countdown, setCountdown] = useState(
        localStorage.getItem('countdown') ? JSON.parse(localStorage.getItem('countdown')) : 0
    );

    const onFinish = (values) => {
        axios.post(API_ROUTES.api_xiaoai_forget, {
            email: values.email,
            password: values.password,
            secretKey: values.secretKey
        }, {}).then(function (response) {
            if (response.data.code === 500) {
                Modal.error({ 
                    title: 'Update Failed',
                    content: response.data.msg 
                });
            } else {
                Modal.success({ 
                    title: 'Success',
                    content: "Password reset successful! Please login with your new password." 
                });
                localStorage.clear();
                navigate('/login');
            }
        }).catch(function (error) {
            Modal.error({ 
                title: 'Error',
                content: error.response?.data?.msgDes || "Failed to reset password. Please check your information." 
            });
        });
    };

    const handleButtonClick = () => {
        const inputEmail = form.getFieldValue('email');
        if (!inputEmail) {
            return Modal.error({ title: 'Input Required', content: 'Please enter your email address first!' });
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(inputEmail)) {
            return Modal.error({ title: 'Invalid Email', content: 'Please enter a valid email address.' });
        }
        
        axios.post(API_ROUTES.api_auth, {
            email: inputEmail,
        }).then(function (response) {
            Modal.success({ 
                title: 'Code Sent',
                content: 'Verification code sent to your email!' 
            });
        }).catch(function (error) {
            Modal.error({ 
                title: 'Error',
                content: 'Failed to send verification code. Please try again.' 
            });
            setIsDisabled(false);
            localStorage.removeItem('countdown');
        });

        setCountdown(60);
        setIsDisabled(true);
    };

    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prevCountdown) => {
                    const next = prevCountdown - 1;
                    localStorage.setItem('countdown', JSON.stringify(next));
                    return next;
                });
            }, 1000);
        } else {
            setIsDisabled(false);
            localStorage.removeItem('countdown');
        }
        return () => clearInterval(timer);
    }, [countdown]);

    return (
        <div className="shared-auth-page" style={{ backgroundColor: '#f0f5ff', minHeight: '100vh', paddingBottom: '80px' }}>
            {/* Header Section */}
            <div className="shared-auth-hero-banner" style={{
                height: '240px',
                padding: '60px 20px',
                textAlign: 'center',
                color: 'white',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <Button 
                    type="text" 
                    icon={<ArrowLeftOutlined />} 
                    style={{ color: 'white', position: 'absolute', left: '20px', top: '20px' }}
                    onClick={() => navigate('/login')}
                >
                    Back to Login
                </Button>
                <Title level={1} style={{ color: 'white', margin: 0, fontWeight: 800 }}>Reset Password</Title>
                <Paragraph style={{ color: 'rgba(255,255,255,0.8)', marginTop: '8px', fontSize: '16px' }}>
                    Follow the steps below to securely regain access to your account.
                </Paragraph>
            </div>

            {/* Form Card */}
            <div className="shared-auth-card-wrap">
                <Card 
                    style={{ 
                        width: '100%', 
                        maxWidth: '550px', 
                        borderRadius: '24px', 
                        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '40px' }}
                >
                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <div style={{ 
                            width: '64px', 
                            height: '64px', 
                            backgroundColor: '#fff1f0', 
                            borderRadius: '50%', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            margin: '0 auto 16px',
                            color: '#cf1322',
                            fontSize: '28px'
                        }}>
                            <KeyOutlined />
                        </div>
                        <Title level={3} style={{ margin: 0, color: '#055878' }}>Account Recovery</Title>
                        <Text type="secondary">Enter your email to receive a recovery key</Text>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        name="forget_password"
                        onFinish={onFinish}
                        requiredMark={false}
                        size="large"
                    >
                        <Form.Item
                            label={<Text strong>Email Address</Text>}
                            name="email"
                            rules={[
                                { required: true, message: 'Please input your email!' },
                                { type: 'email', message: 'Please enter a valid email!' }
                            ]}
                        >
                            <Input 
                                prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} 
                                placeholder="Registered email address" 
                                style={{ borderRadius: '10px' }}
                            />
                        </Form.Item>

                        <Row gutter={12}>
                            <Col xs={24} sm={16}>
                                <Form.Item
                                    label={<Text strong>Verification Key</Text>}
                                    name="secretKey"
                                    rules={[{ required: true, message: 'Please input the secret key!' }]}
                                >
                                    <Input 
                                        prefix={<KeyOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} 
                                        placeholder="Enter key from email"
                                        style={{ borderRadius: '10px' }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={8}>
                                <Form.Item label="&nbsp;">
                                    <Button
                                        onClick={handleButtonClick}
                                        disabled={isDisabled}
                                        type="primary"
                                        block
                                        style={{ 
                                            borderRadius: '10px',
                                            height: '40px',
                                            background: isDisabled ? undefined : '#055878',
                                            fontSize: '13px'
                                        }}
                                    >
                                        {isDisabled ? `${countdown}s` : 'Get Key'}
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item
                            label={<Text strong>New Password</Text>}
                            name="password"
                            rules={[{ required: true, message: 'Please set a new password!' }]}
                        >
                            <Input.Password 
                                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="New password"
                                style={{ borderRadius: '10px' }}
                            />
                        </Form.Item>

                        <Form.Item
                            label={<Text strong>Confirm New Password</Text>}
                            name="confirmPassword"
                            dependencies={['password']}
                            rules={[
                                { required: true, message: 'Please confirm your password!' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject('The two passwords do not match!');
                                    }
                                })
                            ]}
                        >
                            <Input.Password 
                                prefix={<SafetyCertificateOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="Confirm new password"
                                style={{ borderRadius: '10px' }}
                            />
                        </Form.Item>

                        <Form.Item style={{ marginTop: '40px', marginBottom: 0 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                block
                                size="large"
                                style={{
                                    height: '56px',
                                    borderRadius: '28px',
                                    background: 'linear-gradient(135deg, #055878 0%, #13769a 100%)',
                                    border: 'none',
                                    fontSize: '18px',
                                    fontWeight: '700',
                                    boxShadow: '0 8px 20px rgba(5, 88, 120, 0.25)'
                                }}
                            >
                                Reset Password
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
            
            <div style={{ textAlign: 'center', marginTop: '30px' }}>
                 <Space>
                    <Text type="secondary">Remember your password?</Text>
                    <Link onClick={() => navigate('/login')} style={{ color: '#055878', fontWeight: 600 }}>Back to Login</Link>
                </Space>
            </div>
        </div>
    );
}
